const _strings = {
  comment_prompt: {
    'en-US': 'What is your feedback?',
    'en-GB': 'What is your feedback?',
    'it-IT': "Che cos'è il feedback?",
    'fr-FR': 'Quelle est votre évaluation ?Q',
    'ja-JP': 'ご意見を入力してください。',
    'en-IN': 'What is your feedback?',
    'es-ES': '¿Cuál es tu valoración?',
    'es-MX': '¿Cuál es tu valoración?',
    'en-CA': 'What is your feedback?',
    'pt-BR': 'Qual é a sua avaliação?',
    'zh-CN': '您的反馈是什么？',
    'tr-TR': 'Geri bildiriminiz nedir?',
    'ko-KR': '귀하의 피드백은 무엇입니까?',
    'de-DE': 'Wie lautet Ihre Bewertung?',
    'ar-AE': 'ما هي ملاحظاتك؟',
  },
  rating_prompt: {
    'en-US': 'How satisfied are you with the features on this page?',
    'en-GB': 'How satisfied are you with the features on this page?',
    'it-IT':
      'Quanto ti soddisfano le funzionalità disponibili in questa pagina?',
    'fr-FR':
      'Quel est votre degré de satisfaction concernant les fonctionnalités de cette page ?',
    'ja-JP': 'このページの機能にどのくらい満足していただけましたか？',
    'en-IN': 'How satisfied are you with the features on this page?',
    'es-ES':
      '¿Cuál es tu nivel de satisfacción con las funcionalidades de esta página?',
    'es-MX':
      '¿Cuál es tu nivel de satisfacción con las funcionalidades de esta página?',
    'en-CA': 'How satisfied are you with the features on this page?',
    'pt-BR': 'Qual é o seu nível de satisfação com os recursos nesta página?',
    'zh-CN': '您对此页面上的几种功能的满意度如何？您',
    'tr-TR': 'Bu sayfadaki özelliklerden ne kadar memnunsunuz?',
    'ko-KR': '이 페이지의 기능에 대해 어느 정도 만족하십니까?이',
    'de-DE': 'Wie zufrieden sind Sie mit den Funktionen auf dieser Seite?',
    'ar-AE': 'ما مدى رضاك ​​عن الميزات الموجودة في هذه الصفحة؟',
  },
  submit_label: {
    'en-US': 'Submit',
    'en-GB': 'Submit',
    'it-IT': 'Invia',
    'fr-FR': 'Envoyer',
    'ja-JP': '送信',
    'en-IN': 'Submit',
    'es-ES': 'Enviar',
    'es-MX': 'Submit',
    'en-CA': 'Submit',
    'pt-BR': 'Enviar',
    'zh-CN': '提交',
    'tr-TR': 'Gönder',
    'ko-KR': '제출제',
    'de-DE': 'Absenden',
    'ar-AE': 'إرسال',
  },
  cancel_label: {
    'en-US': 'Cancel',
    'en-GB': 'Cancel',
    'it-IT': 'Annulla',
    'fr-FR': 'Annuler',
    'ja-JP': 'キャンセルキ',
    'en-IN': 'Cancel',
    'es-ES': 'Cancelar',
    'es-MX': 'Cancelar',
    'en-CA': 'Cancel',
    'pt-BR': 'Cancelar',
    'zh-CN': '取消',
    'tr-TR': 'İptal',
    'ko-KR': '취소',
    'de-DE': 'Abbrechen',
    'ar-AE': 'إلغاء',
  },
  charlimit: {
    'en-US': '500 character limit',
    'en-GB': '500 character limit',
    'it-IT': 'Limite di 500 caratteri',
    'fr-FR': 'Limite de 500 caractères',
    'ja-JP': '500 文字の制限',
    'en-IN': '500 character limit',
    'es-ES': 'Límite de 500 caracteres',
    'es-MX': 'Cancelar',
    'en-CA': '500 character limit',
    'pt-BR': 'Limite de 500 caracteres',
    'zh-CN': '500字符极限',
    'tr-TR': '500 karakter sınırı',
    'ko-KR': '500 자 제한',
    'de-DE': 'Maximal 500 Zeichen',
    'ar-AE': 'لحد 500 حرف',
  },
  disclaimer: {
    'en-US':
      'Examples of personal or sensitive data include names, addresses, telephone numbers, or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree you have not included this data.',
    'zh-CN':
      '个人或敏感数据的示例包括姓名、地址、电话号码或电子邮件地址。 完成此调查不需要个人或敏感数据。 提交您的回复，即表示您同意您未包含此数据。',
    'fr-FR':
      'Les exemples de données personnelles ou sensibles incluent les noms, les adresses, les numéros de téléphone, ou les adresses e-mail. Les données personnelles ou sensibles ne sont pas nécessaires pour répondre à ce questionnaire. En soumettant votre réponse, vous acceptez que vous n’avez pas inclus ces données.',
    'it-IT':
      'Esempi di dati personali o sensibili sono nome, indirizzo, telefono, indirizzo e-mail. Non è necessario inserire dati personali o sensibili per completare questo sondaggio. Inviando la tua risposta, accetti e confermi di non aver inserito tali dati.',
    'es-ES':
      'Ejemplos de datos personales o confidenciales: nombres o números de teléfono, direcciones de correo electrónico, etc. Los daros personales o confidenciales no son necesarios para completar esta encuesta. Al enviar esta respuesta de encuesta, garantizas que no has incluido ningún dato de este tipo.',
    'de-DE':
      'Beispiele für persönliche oder vertrauliche Daten sind Namen, Adressen, Telefonnummern und E-Mail-Adressen.  Persönliche oder vertrauliche Daten sind nicht erforderlich, um an dieser Umfrage teilzunehmen.  Mit der Übermittlung Ihrer Antwort bestätigen Sie, dass Sie keine dieser Daten hinzugefügt haben. ',
    'es-MX':
      'Ejemplos de información personal o confidencial incluyen nombres, direcciones, números telefónicos o direcciones de correo electrónico. No es necesario proporcionar información personal o confidencial para completar esta encuesta. Al enviar tu respuesta, aceptas que no se incluyen estos datos.',
    'en-CA':
      'Examples of personal or sensitive data include names, addresses, telephone numbers, or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree you have not included this data.',
    'en-GB':
      'Examples of personal or sensitive data include names, addresses, telephone numbers, or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree you have not included this data.',
    'en-IN':
      'Examples of personal or sensitive data include names, addresses, telephone numbers or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree you have not included this data.',
    'pt-BR':
      'Exemplos de dados pessoais ou confidenciais incluem nomes, endereços, números de telefone e endereços de e-mail. Dados pessoais ou confidenciais não são necessários para concluir esta pesquisa. Ao enviar sua resposta, você concorda que você não incluiu esses dados.',
    'ko-KR':
      '이름, 주소, 전화번호 또는 이메일 주소 등이 개인 또는 민감한 데이터에 포함됩니다. 이 설문 조사를 완료하기 위해 개인 또는 민감한 데이터를 제공할 필요가 없습니다. 귀하의 응답을 제출함으로써 이 데이터를 포함하지 않았다는 것에 동의하게 됩니다.',
    'ja-JP':
      '個人データまたは機密データの例には、名前、住所、電話番号、またはEメールアドレスなどがあります。 この調査を完了するには、個人データまたは機密データは必要ありません。 レスポンスを送信すると、このデータを含めなかったことに同意したとみなされます。',
    'tr-TR':
      'Kişisel veya hassas verilere örnek olarak; ad, adres, telefon numaraları veya e-posta adresleri gösterilebilir. Bu anketi tamamlamanız için kişisel veya hassas veriler gerekmemektedir. Bu anket yanıtlarınızı göndererek, anket yanıtlarınızda bu tür verilerin olmadığını beyan etmiş olursunuz.',
    'ar-AE':
      '. أمثلة على البيانات الشخصية أو الحساسة مثل الأسماء أو العناوين أو أرقام الهاتف أو عناوين البريد الإلكتروني. البيانات الشخصية أو الحساسة ليست ضرورية لاستكمال هذا الاستطلاع. بإرسال ردك ، أنت توافق على أنك لم تقم بإرسال هذه البيانات',
  },
  subject_prompt: {
    'en-US': 'Feedback subject',
    'zh-CN': '反馈主题',
    'fr-FR': "Sujet de l'évaluation",
    'it-IT': 'Argomento del feedback',
    'es-ES': 'Asunto de la valoración',
    'de-DE': 'Thema der Bewertung',
    'es-MX': 'Asunto de la valoración',
    'en-CA': 'Feedback subject',
    'en-GB': 'Feedback subject',
    'en-IN': 'Feedback subject',
    'pt-BR': 'Assunto da avaliação',
    'ko-KR': '피드백 제목',
    'ja-JP': '件名',
    'tr-TR': 'Geri bildirim konusu',
    'ar-AE': 'عنوان ملاحظاتك',
  },
  subject_select: {
    'en-US': 'Select a subject',
    'zh-CN': '请选择一个主题',
    'fr-FR': 'Sélectionner un sujet',
    'it-IT': 'Seleziona un argomento',
    'es-ES': 'Selecciona un asunto',
    'de-DE': 'Wählen Sie ein Thema aus',
    'es-MX': 'Selecciona un asunto',
    'en-CA': 'Select a subject',
    'en-GB': 'Select a subject',
    'en-IN': 'Select a subject',
    'pt-BR': 'Selecionar um assunto',
    'ko-KR': '제목 선택',
    'ja-JP': '件名を選択',
    'tr-TR': 'Bir konu seçin',
    'ar-AE': 'إختر العنوان',
  },
  subject_suggestion: {
    'en-US': 'Suggestion',
    'zh-CN': '建议',
    'fr-FR': 'Suggestion',
    'it-IT': 'Suggerimento',
    'es-ES': 'Sugerencia',
    'de-DE': 'Vorschlag',
    'es-MX': 'Sugerencia',
    'en-CA': 'Suggestion',
    'en-GB': 'Suggestion',
    'en-IN': 'Suggestion',
    'pt-BR': 'Sugestão',
    'ko-KR': '제안 사항',
    'ja-JP': '提案',
    'tr-TR': 'Öneri',
    'ar-AE': 'مقترحات',
  },
  subject_technical: {
    'en-US': 'Technical issue',
    'zh-CN': '技术问题',
    'fr-FR': 'Problème technique',
    'it-IT': 'Problema tecnico',
    'es-ES': 'Problema técnico',
    'de-DE': 'Technisches Problem',
    'es-MX': 'Problema técnico',
    'en-CA': 'Technical issue',
    'en-GB': 'Technical issue',
    'en-IN': 'Technical issue',
    'pt-BR': 'Problema técnico',
    'ko-KR': '기술 문제',
    'ja-JP': '技術的な問題',
    'tr-TR': 'Teknik sorun',
    'ar-AE': 'مشكلة فنيه',
  },
  subject_compliment: {
    'en-US': 'Compliment',
    'zh-CN': '正面',
    'fr-FR': 'Compliment',
    'it-IT': 'Complimento',
    'es-ES': 'Felicitaciones',
    'de-DE': 'Kompliment',
    'es-MX': 'Felicitaciones',
    'en-CA': 'Compliment',
    'en-GB': 'Compliment',
    'en-IN': 'Compliment',
    'pt-BR': 'Elogio',
    'ko-KR': '칭찬',
    'ja-JP': '良かった点',
    'tr-TR': 'Övgü',
    'ar-AE': 'مجامله',
  },
  subject_other: {
    'en-US': 'Other',
    'zh-CN': '其他',
    'fr-FR': 'Autre',
    'it-IT': 'Altro',
    'es-ES': 'Otros',
    'de-DE': 'Sonstiges',
    'es-MX': 'Otros',
    'en-CA': 'Other',
    'en-GB': 'Other',
    'en-IN': 'Other',
    'pt-BR': 'Outros',
    'ko-KR': '기타',
    'ja-JP': 'その他',
    'tr-TR': 'Diğer',
    'ar-AE': 'أخرى',
  },
  chars_remaining: {
    'en-US': 'characters remaining',
    'zh-CN': '剩余字符数',
    'fr-FR': 'caractères restants',
    'it-IT': 'caratteri rimasti',
    'es-ES': 'caracteres restantes',
    'de-DE': 'verbleibende Zeichen',
    'es-MX': 'caracteres restantes',
    'en-CA': 'characters remaining',
    'en-GB': 'characters remaining',
    'en-IN': 'characters remaining',
    'pt-BR': 'caracteres restantes',
    'ko-KR': '자 남음',
    'ja-JP': '文字入力できます',
    'tr-TR': 'karakter kaldı',
    'ar-AE': 'الأحرف المتبقية',
  },
  thanks: {
    'en-US': 'Thank you! Your feedback has been submitted.',
    'zh-CN': '谢谢！您的反馈已提交。',
    'fr-FR': 'Merci ! Votre évaluation a été envoyée.',
    'it-IT': 'Grazie! Il suo feedback è stato inviato.',
    'es-ES': '¡Gracias! Tu valoración se ha enviado correctamente.',
    'de-DE': 'Vielen Dank! Ihre Bewertung wurde übermittelt.',
    'es-MX': '¡Gracias! Tu valoración se ha enviado correctamente.',
    'en-CA': 'Thank you! Your feedback has been submitted.',
    'en-GB': 'Thank you! Your feedback has been submitted.',
    'en-IN': 'Thank you! Your feedback has been submitted.',
    'pt-BR': 'Obrigado! Sua avaliação foi enviada.',
    'ko-KR': '감사합니다. 귀하의 피드백이 제출되었습니다.',
    'ja-JP': 'ありがとうございました。フィードバックが送信されました。',
    'tr-TR': 'Thank you! Your feedback has been submitted.',
    'ar-AE': 'شكرا لك! لقد تم إرسال ملاحظتك',
  },
  popup_prompt: {
    'en-US': 'What is personal or sensitive data?',
    'zh-CN': '什么是个人或敏感数据？',
    'fr-FR': 'Que sont les données personnelles ou sensibles ?',
    'it-IT': 'Cosa sono i dati personali o riservati?',
    'es-ES': '¿Qué son los datos personales o confidenciales?',
    'de-DE': 'Was sind personenbezogene oder sensible Daten?',
    'es-MX': '¿Qué son los datos personales o confidenciales?',
    'en-CA': 'What is personal or sensitive data?',
    'en-GB': 'What is personal or sensitive data?',
    'en-IN': 'What is personal or sensitive data?',
    'pt-BR': 'O que são dados pessoais ou confidenciais?',
    'ko-KR': '개인 데이터 또는 민감한 데이터는 무엇입니까?',
    'ja-JP': '個人情報や機密性の高いデータとは何ですか ?',
    'tr-TR': 'Kişisel veya hassas veriler nedir?',
    'ar-AE': 'ما هي البيانات الشخصية أو الحساسة؟',
  },
  textarea_placeholder: {
    'en-US': 'Do not include personal or sensitive data in your feedback.',
    'zh-CN': '请勿在您的反馈中包含个人或敏感数据。',
    'fr-FR':
      "N'incluez pas de données personnelles ou sensibles dans vos commentaires.",
    'it-IT':
      "Non inserire dati personali o sensibili all'interno del testo relativo al tuo feedback.",
    'es-ES': 'No incluyas datos personales o confidenciales en tu valoración.',
    'de-DE':
      'Fügen Sie keine persönlichen oder vertraulichen Daten zu Ihrem Feedback hinzu. ',
    'es-MX':
      'No incluyas datos personales o confidenciales en tus comentarios.',
    'en-CA': 'Do not include personal or sensitive data in your feedback.',
    'en-GB': 'Do not include personal or sensitive data in your feedback.',
    'en-IN': 'Do not include personal or sensitive data in your feedback.',
    'pt-BR': 'Não inclua dados pessoais ou confidenciais em seus comentários.',
    'ko-KR': '피드백에 개인 또는 민감한 데이터를 포함하지 마십시오.',
    'ja-JP':
      '個人情報や機密性の高いデータをフィードバックに含めないでください。',
    'tr-TR': 'Geri bildiriminize kişisel veya hassas verileri dahil etmeyin.',
    'ar-AE': 'لا ترسل بيانات شخصية أو حساسة بملاحظاتك',
  },
  modal_title: {
    'en-US': 'Rate This Page',
    'zh-CN': '为此页评级',
    'fr-FR': 'Évaluez cette page',
    'it-IT': 'Valuta questa pagina',
    'es-ES': 'Valora esta página',
    'de-DE': 'Diese Seite bewerten',
    'es-MX': 'Calificar esta página',
    'en-CA': 'Rate This Page',
    'en-GB': 'Rate this page',
    'en-IN': 'Rate This Page',
    'pt-BR': 'Avaliar esta página',
    'ko-KR': '이 페이지 평가',
    'ja-JP': 'このページを評価する',
    'tr-TR': 'Bu sayfayı değerlendir',
    'ar-AE': 'قم بتقييم هذه الصفحة',
  },
  very_unsatisfied_option: {
    'en-US': 'very unsatisfied',
    'fr-FR': 'très insatisfait',
    'zh-CN': '非常不满意',
    'ja-JP': '非常に不満',
    'es-ES': 'muy insatisfecho',
    'de-DE': 'sehr unzufrieden',
    'es-MX': 'muy insatisfecho',
    'it-IT': 'Molto insoddisfatto',
    'en-CA': 'very unsatisfied',
    'en-GB': 'very unsatisfied',
    'en-IN': 'very unsatisfied',
    'ko-KR': '매우 만족함',
    'pt-BR': 'muito insatisfeito',
    'tr-TR': 'hiç memnun değilim',
    'ar-AE': 'غير راضٍ على الإطلاق',
    'en-SG': 'very unsatisfied',
    'nl-NL': 'zeer ontevreden',
  },
  unsatisfied_option: {
    'en-US': 'unsatisfied',
    'ja-JP': '不満',
    'fr-FR': 'insatisfait',
    'zh-CN': '不满意',
    'it-IT': 'Non soddisfatto',
    'es-ES': 'insatisfecho',
    'de-DE': 'unzufrieden',
    'es-MX': 'insatisfecho',
    'en-CA': 'unsatisfied',
    'en-GB': 'unsatisfied',
    'en-IN': 'unsatisfied',
    'pt-BR': 'insatisfeito',
    'ko-KR': '불만족함',
    'tr-TR': 'memnun değilim',
    'ar-AE': 'غير راضٍ',
    'en-SG': 'unsatisfied',
    'nl-NL': 'ontevreden',
  },
  neutral_option: {
    'en-US': 'neutral',
    'zh-CN': '中性',
    'ja-JP': 'どちらでもない',
    'fr-FR': 'neutre',
    'es-ES': 'neutral',
    'de-DE': 'neutral',
    'es-MX': 'neutral',
    'it-IT': 'Indifferente',
    'en-CA': 'neutral',
    'en-GB': 'neutral',
    'en-IN': 'neutral',
    'pt-BR': 'neutro',
    'ko-KR': '보통',
    'tr-TR': 'kararsızım',
    'ar-AE': 'محايد',
    'en-SG': 'neutral',
    'nl-NL': 'neutraal',
  },
  satisfied_option: {
    'en-US': 'satisfied',
    'zh-CN': '满意',
    'ja-JP': '満足',
    'fr-FR': 'satisfait',
    'it-IT': 'Soddisfatto',
    'es-ES': 'satisfecho',
    'de-DE': 'zufrieden',
    'es-MX': 'satisfecho',
    'en-CA': 'satisfied',
    'en-GB': 'satisfied',
    'en-IN': 'satisfied',
    'pt-BR': 'satisfeito',
    'ko-KR': '만족함',
    'tr-TR': 'memnunum',
    'ar-AE': 'راضٍ',
    'en-SG': 'satisfied',
    nl_NL: 'tevreden',
  },
  very_satisfied_option: {
    'en-US': 'very satisfied',
    'zh-CN': '非常满意',
    'ja-JP': '非常に満足',
    'it-IT': 'Molto soddisfatto',
    'fr-FR': 'très satisfait',
    'es-ES': 'muy satisfecho',
    'de-DE': 'sehr zufrieden',
    'es-MX': 'muy satisfecho',
    'en-CA': 'very satisfied',
    'en-GB': 'very satisfied',
    'en-IN': 'very satisfied',
    'pt-BR': 'muito satisfeito',
    'ko-KR': '매우 만족함',
    'tr-TR': 'çok memnunum',
    'ar-AE': 'راضٍ جدًا',
    'en-SG': 'very satisfied',
    'nl-NL': 'zeer tevreden',
  },
};

module.exports = _strings;
